export const CLEAR_MEASUREMENT_EVENT = 'projectv2:clear-measurement'
